import { render, staticRenderFns } from "./ShopStoreTakeoutProductCategory.vue?vue&type=template&id=88b182a6&scoped=true"
import script from "./ShopStoreTakeoutProductCategory.vue?vue&type=script&lang=js"
export * from "./ShopStoreTakeoutProductCategory.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreTakeoutProductCategory.vue?vue&type=style&index=0&id=88b182a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b182a6",
  null
  
)

export default component.exports